import { EWsAnswerActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Не удалось отправить действие по вебсокету
 */
export const setSendAnswerFailed = actionGenerator<EWsAnswerActionTypes.SendFailed, void>(
  EWsAnswerActionTypes.SendFailed,
);

/**
 * Удачная отправка действия по вебсокету
 */
export const setSendAnswerSuccess = actionGenerator<EWsAnswerActionTypes.SendSucceed, void>(
  EWsAnswerActionTypes.SendSucceed,
);

/**
 * Ожидание отправки действия по вебсокету
 */
export const setSendAnswerPending = actionGenerator<EWsAnswerActionTypes.SendPending, void>(
  EWsAnswerActionTypes.SendPending,
);
